import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'

type UnsavedFormModalProps = {
  isOpenUnsavedModal: boolean,
  onCloseUnsavedModal: () => void,
  handleNoClick: () => void,
  handleYesClick: () => void
}

export const UnsavedFormModal = ({ isOpenUnsavedModal,
  onCloseUnsavedModal,
  handleNoClick,
  handleYesClick }: UnsavedFormModalProps) => {

  return (
    <Modal isOpen={isOpenUnsavedModal} onClose={onCloseUnsavedModal} isCentered>
      <ModalOverlay
        bg='none'
        backdropFilter='auto'
        backdropInvert='30%'
        backdropBlur='5px'
      />

      <ModalContent>
        <ModalCloseButton />

        <ModalHeader>Máte neuložené změny ve formuláři</ModalHeader>

        <ModalBody>Přejete si v rozpracovaném formuláři pokračovat?</ModalBody>

        <ModalFooter sx={{ justifyContent: 'center', gap: 4 }}>
          <Button onClick={handleNoClick}>
            Ne
          </Button>

          <Button colorScheme='green' onClick={handleYesClick}>
            Ano
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}